import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../api/client';
import { formatMoney } from './billingShared';

export default function BillingReturnPage() {
  const [params] = useSearchParams();
  const ext = params.get('ext') || '';
  const status = params.get('status') || '';
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(Boolean(ext));

  useEffect(() => {
    if (!ext) return undefined;
    let cancelled = false;
    async function load() {
      try {
        const res = await api.get(`/payments/orders/${ext}/`);
        if (cancelled) return;
        setOrder(res.data);
        setError('');
        if (res.data?.status === 'paid' || res.data?.status === 'failed') {
          setChecking(false);
        }
      } catch (e) {
        if (!cancelled) setError(e.response?.data?.detail || 'Не удалось проверить платёж.');
      }
    }
    load();
    const id = setInterval(load, 2000);
    const stop = setTimeout(() => {
      clearInterval(id);
      if (!cancelled) setChecking(false);
    }, 90000);
    return () => {
      cancelled = true;
      clearInterval(id);
      clearTimeout(stop);
    };
  }, [ext]);

  const paid = order?.status === 'paid';
  const failed = status === 'fail' || order?.status === 'failed';

  return (
    <div className="billing-page">
      <div className="page-header">
        <h1>{paid ? 'Оплата прошла' : failed ? 'Оплата не прошла' : 'Проверяем оплату…'}</h1>
        <p className="page-subtitle">
          {paid
            ? `На семейный счёт зачислено ${formatMoney(order.amount)}.`
            : checking
              ? 'Если вы уже оплатили, подождите — сверяем статус с Озон Пай.'
              : 'Если оплата прошла, откройте баланс через несколько секунд или нажмите «Проверить ещё раз».'}
        </p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      <p style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
        <Link to="/billing" className="btn btn-primary">К балансу</Link>
        {!paid && ext && (
          <button
            type="button"
            className="btn btn-outline"
            onClick={async () => {
              setChecking(true);
              setError('');
              try {
                const res = await api.get(`/payments/orders/${ext}/`);
                setOrder(res.data);
              } catch (e) {
                setError(e.response?.data?.detail || 'Не удалось проверить платёж.');
              } finally {
                setChecking(false);
              }
            }}
          >
            Проверить ещё раз
          </button>
        )}
      </p>
    </div>
  );
}
